var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.92 165.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}.cls-3{fill:#0c0c0c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.86,83A82.83,82.83,0,1,1,83,0,82.92,82.92,0,0,1,165.86,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.91,124.85c.51,3.56-3.94,1.85-7.83,5.55s-4.89,5.83-9.54,3.5c-4.15-2.07,3.15-11.86,6.54-13.06S128.18,119.79,128.91,124.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.85,141.15a83.94,83.94,0,0,0,12.2,10.23c3.21-4.75,8.18-9.46,14.84-7.91,16.48,3.82,19.55-32.31,2.25-31.27-14.11.84-3-14.12-17.32-9.83a19.52,19.52,0,0,1-4.73.82C21.19,120.25,18,134.54,23.85,141.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.1,85.72C32.53,84.5,44.29,81,47.19,68.5,50.27,55.21,32.54,51.31,36.1,43,40,33.85,71.65,45.9,71.65,31.5c0-7.91-9.4-5.71-15.74-7.28C48.06,22.28,44.65,16,43.47,10a83.17,83.17,0,0,0-42.76,62c-.06.46-.12.92-.17,1.38-.08.7-.15,1.4-.22,2.1S.23,76.69.19,77.28s-.09,1.3-.12,2,0,1.41,0,2.11c0,1.24,0,2.48,0,3.72,0,.37,0,.74,0,1.1,0,1,.09,1.9.16,2.85l0,.46q.26,3.21.76,6.45a83.18,83.18,0,0,0,6.11,20.72l0,0c.55,1.23,1.13,2.44,1.73,3.64l.18.34c.56,1.11,1.15,2.2,1.76,3.27.09.17.19.33.28.49.6,1,1.22,2,1.86,3,.11.17.21.35.33.52q1,1.5,2,3l.3.41c.74,1,1.5,2,2.28,3a1.56,1.56,0,0,0,.16.2,80.38,80.38,0,0,0,5.82,6.54c-5.88-6.61-2.66-20.9,7.24-38C18.46,103.75,14.78,89.39,28.1,85.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.9,70a82.61,82.61,0,0,0-18.9-41,56.3,56.3,0,0,0-5.08,6.11C137,40.59,128.77,40.85,124.29,32a19.15,19.15,0,0,0-7-7.78c-8.18,3.16-17.59,8.49-27.45,15.62-1.62,7.38.59,15.67,13.16,16.59,16.31,1.19,7.9,17.46-2,13.83S86.15,63,78,69.5,71.23,87,81,88.6c6.94,1.13,10.52,10.91,7.8,14-3.86,3.41-9.3,17-2,25.11s12.76,2.37,14.81-2.34,2.14-7.85,5.87-14.12c2.78-4.69,12.43-6.76,12.43-6.76s7.93-2.85,2.42-17.57S136,74.61,140.22,84.53c3.53,8.3-4.87,21.93,10,19.53,6.65-1.08,9.21,2.27,11.65,4.54A82.54,82.54,0,0,0,164.9,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.13,38.53c-.13.43-.23.87-.33,1.31,9.86-7.13,19.27-12.46,27.45-15.62C108,18.54,94.81,22.11,90.13,38.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.52,15.62A10.21,10.21,0,0,0,66.38,5.41h0A10.22,10.22,0,0,0,56.18,15.62a12.28,12.28,0,0,0,1.2,5.19,113.85,113.85,0,0,0,9,14.59h0c1.35-1.65,7.43-10.94,9-14.59A14.1,14.1,0,0,0,76.52,15.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 66.35,
    cy: 15.44,
    r: 5.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.46,89.29a10.21,10.21,0,0,0-10.15-10.21h0A10.21,10.21,0,0,0,92.12,89.29a12.28,12.28,0,0,0,1.19,5.19,115,115,0,0,0,9,14.59s0,0,0,0c1.36-1.65,7.44-10.94,9-14.59A14.31,14.31,0,0,0,112.46,89.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.29,
    cy: 89.11,
    r: 5.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.82,74.12a10.21,10.21,0,0,0-10.15-10.21h0a10.2,10.2,0,0,0-10.14,10.21,12.2,12.2,0,0,0,1.19,5.18,112.46,112.46,0,0,0,9,14.59s0,0,0,0c1.35-1.65,7.43-10.94,9-14.6A14,14,0,0,0,163.82,74.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 153.65,
    cy: 73.94,
    r: 5.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.12,23.42A10.21,10.21,0,0,0,99,13.21h0A10.22,10.22,0,0,0,88.78,23.42,12.25,12.25,0,0,0,90,28.61a113.85,113.85,0,0,0,9,14.59h0c1.35-1.65,7.43-10.94,9-14.59A14.1,14.1,0,0,0,109.12,23.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.95,
    cy: 23.25,
    r: 5.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.47,59.19A10.21,10.21,0,0,0,23.32,49h0A10.21,10.21,0,0,0,13.13,59.19a12.24,12.24,0,0,0,1.19,5.18,113.57,113.57,0,0,0,9,14.59,0,0,0,0,0,0,0c1.35-1.64,7.43-10.94,9-14.59A14.3,14.3,0,0,0,33.47,59.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.3,
    cy: 59.01,
    r: 5.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.43,96.81A10.2,10.2,0,0,0,56.29,86.6h0A10.21,10.21,0,0,0,46.09,96.81a12.2,12.2,0,0,0,1.2,5.18,112.46,112.46,0,0,0,9,14.59s0,0,0,0c1.35-1.65,7.43-10.94,9-14.6A14,14,0,0,0,66.43,96.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 56.26,
    cy: 96.63,
    r: 5.13
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.84407592989df9d41800f6e3ce0b8bb6.svg";
export { ForwardRef as ReactComponent };